import { EnvironmentAction } from './environment.action';
import { InitializerAction } from '../initializer/initiliazer.action';

export class EnvironmentState {
    public error: null;
    public history: string[];
    public environments: string[];
    public currentIndex: number;
    public loadingMachine: boolean;
    public currentEnvironment: string;
    public loadingEnvironments: boolean;
    public previousEnvironment: string;
    public environmentUntouched: boolean;
    public machine: {
        value?: string,
    };
}

export const initialState: EnvironmentState = {
    error: null,
    history: [],
    machine: {},
    environments: [],
    currentIndex: -1,
    loadingMachine: false,
    loadingEnvironments: false,
    currentEnvironment: null,
    previousEnvironment: null,
    environmentUntouched: true,
};

export function EnvironmentReducer(state: EnvironmentState = initialState, action: EnvironmentAction) {

    switch (action.type) {

        case EnvironmentAction.getEnvironments: return {
            ...state,
            ...{
                error: null,
                loadingEnvironments: true,
            },
        };

        case EnvironmentAction.getEnvironmentsSuccess: return {
            ...state,
            ...{
                error: null,
                environments: action.payload,
                loadingEnvironments: false,
            },
        };

        case EnvironmentAction.getEnvironmentsError: return {
            ...state,
            ...{
                error: action.payload,
                loadingEnvironments: false,
            },
        };

        case EnvironmentAction.setCurrentEnvironment: return {
            ...state,
            ...{
                currentEnvironment: action.payload,
                previousEnvironment: state.currentEnvironment,
                history: [
                    ...state.history,
                    action.payload,
                ],
            },
        };

        case EnvironmentAction.resetCurrentEnvironment: return {
            ...state,
            ...{
                currentEnvironment: null,
            },
        };

        case EnvironmentAction.getEnvironmentMachine: return {
            ...state,
            ...{
                loadingMachine: true,
            },
        };


        case EnvironmentAction.getEnvironmentMachineSuccess: return {
            ...state,
            ...{
                machine: action.payload,
                loadingMachine: false,
            },
        };

        case EnvironmentAction.getEnvironmentMachineError: return {
            ...state,
            ...{
                machine: action.payload,
                loadingMachine: false,
            },
        };

        case InitializerAction.resetUserRelatedData: return {
            ...state,
            ...{
                environments: initialState.environments,
                history: initialState.history,
            },
        };

        default: return state;

    }

}
